import React from 'react';

export default () => (
	<iframe src="/HtmlClient/MyAlerts.html" style={{ width: '100%', height: '100%' }}></iframe>
);